module.exports = __webpack_public_path__ + "static/media/locate-icon.5d035ae3.svg";